/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>注册用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.nickName" placeholder="昵称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.phone" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small"  @click="resetting">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column  prop="id" label="用户id">
      </el-table-column>
      <el-table-column  prop="nickname" label="昵称">
      </el-table-column>
      <el-table-column  prop="phone" label="手机号" >
      </el-table-column>
      <el-table-column  prop="zsCount" label="钻石">
      </el-table-column>
      <el-table-column  prop="integral" label="积分">
      </el-table-column>
      
      <el-table-column  prop="createdAt" label="注册时间" >
        <template slot-scope="scope">
          <div>{{scope.row.createdAt|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button type="text" v-preventReClick @click="handleEdit(scope.row)">查看详情</el-button>
          <el-button type="text" v-preventReClick @click="addintegralClick(scope.row.id , 1)">加约豆</el-button>
          <el-button type="text" v-preventReClick @click="addintegralClick(scope.row.id , 0)">减约豆</el-button>
          <el-button type="text" v-preventReClick @click="diamondClick(scope.row.id , 1)">加钻石</el-button>
          <el-button type="text" v-preventReClick @click="diamondClick(scope.row.id , 0)">减钻石</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="" :visible.sync="editFormVisible" width="40%" @click="closeDialog">
      <!-- <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="头像">
          <el-image
            style="width: 100px; height: 100px"
            :src="editForm.avatar"
            fit="fit"></el-image>
        </el-form-item>
        <el-form-item label="用户id">
          <el-input size="small" v-model="editForm.id" disabled="" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称" >
          <el-input size="small" v-model="editForm.nickname" disabled="" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
        <el-form-item label="用户手机号" >
          <el-input size="small" v-model="editForm.phone" disabled="" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
      </el-form> -->
      <el-descriptions title="基本信息">
          <el-descriptions-item label="用户头像">
            <img style="width:68px;height:68px;border-radius: 50%;" :src="editForm.avatar">
            <el-tag @click="editSubmit(editForm.avatar = '')" size="small">删除</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="背景图">
            <img style="width:68px;height:68px;" :src="editForm.bg_pic">
            <el-tag @click="editSubmit(editForm.bg_pic = '')" size="small">删除</el-tag>
          </el-descriptions-item>
          
          <el-descriptions-item label="用户昵称">{{editForm.nickname}}<el-tag @click="editSubmit(editForm.nickname = '')" size="small">删除</el-tag></el-descriptions-item>
          <el-descriptions-item label="用户id">{{editForm.id}}</el-descriptions-item>
          <el-descriptions-item label="用户手机号">{{editForm.phone}}</el-descriptions-item>
          <el-descriptions-item label="注册时间">{{editForm.created_at}}</el-descriptions-item>
          <el-descriptions-item label="性别">{{editForm.gender == 1?'男':'女' }}</el-descriptions-item>
          <el-descriptions-item label="出生日期">{{editForm.birth}}</el-descriptions-item>
          <el-descriptions-item label="简介">{{editForm.content}}<el-tag @click="editSubmit(editForm.content = '')" size="small">删除</el-tag></el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="互动">
        <el-descriptions-item label="数据"><div>{{editForm.otherData.interest}}获赞 {{editForm.otherData.friends}}朋友 {{editForm.otherData.flw}}关注 {{editForm.otherData.fans}}粉丝</div></el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="约豆">
        <el-descriptions-item label="剩余">{{editForm.integral}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="游戏等级">
        <el-descriptions-item label="当前">lv{{editForm.otherData.gamelevel.od}}<span v-if="editForm.otherData.expvalue != 0">,还差{{editForm.otherData.expvalue}}经验升级</span></el-descriptions-item>
      </el-descriptions>
      <el-descriptions title="登录设备">
        <el-descriptions-item label="是否在线">{{editForm.machine_id == null?'离线':'在线'}}</el-descriptions-item>
        <el-descriptions-item label="设备" v-if="editForm.machine_id != null">{{editForm.machine_id}}</el-descriptions-item>
        <el-descriptions-item v-if="editForm.machine_id != null" label="操作"><el-tag style="cursor: pointer;" @click="unLogin()" size="small">登出娱乐机</el-tag></el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" v-preventReClick @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 增减约豆 -->
    <el-dialog :title="title" :visible.sync="addintegralFlag" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="addintegralForm" :rules="rules" ref="addintegralForm">
        <el-form-item label="数量" prop="count">
          <el-input size="small" v-model="addintegralForm.count" auto-complete="off" placeholder="请输入数量"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addintegralFlag">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" v-preventReClick @click="addintegralSubmit('addintegralForm')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 增减约豆 -->
    <el-dialog :visible.sync="diamondFlag" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="diamondForm" :rules="rules" ref="diamondForm">
        <el-form-item label="数量" prop="count">
          <el-input size="small" v-model="diamondForm.count" auto-complete="off" placeholder="请输入数量"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="diamondFlag = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" v-preventReClick @click="diamondSubmit('diamondForm')">保存</el-button>
      </div>
    </el-dialog>

    
  </div>
</template>
<script>
import { getCustomerList , loadCustomerList  , addUsersIntegral , usersDetail , usersUpdate  , addUsersDiamond , usersExist} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        otherData:{
          gamelevel:{}
        }
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        count: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        phone: '',
        nickName: '',
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      addintegralFlag:false,
      type:'',
      id:'',
      addintegralForm:{
        count:''
      },
      diamondForm:{
        count:''
      },
      diamondFlag:false
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    unLogin(){
      usersExist(this.editForm.id).then(res=>{
        if(!res.success){
          this.$message.error(res.message)
        }else {
          this.$message.success('操作成功')
          this.handleEdit(this.editForm)
        }
      })
    },
    diamondSubmit(editData){
      this.$refs[editData].validate(valid => {
        if (valid) {
          addUsersDiamond({
            id:this.id,
            type:this.type,
            count:this.diamondForm.count
          }).then(res=>{
            if(!res.success){
              this.$message.error(res.message)
            }else {
              this.getdata()
              this.diamondFlag = false
              this.$message.success('操作成功')
            }
          })
        } else {
          return false
        }
      })
    },
    diamondClick(id , type){
      this.diamondFlag = true
      this.type = type
      this.id = id
      this.diamondForm.count = ''
    },
    editSubmit(){
      usersUpdate(this.editForm).then(res=>{
        if(!res.success){
          this.$message.error(res.message)
        }else {
          this.$message.success('操作成功')
        }
      })
    },
    addintegralClick(id , type){
      this.addintegralFlag = true
      this.type = type
      this.id = id
      this.addintegralForm.count = ''
    },
    addintegralSubmit(editData){
      this.$refs[editData].validate(valid => {
        if (valid) {
          addUsersIntegral({
            id:this.id,
            type:this.type,
            count:this.addintegralForm.count
          }).then(res=>{
            if(!res.success){
              this.$message.error(res.message)
            }else {
              this.getdata()
              this.addintegralFlag = false
              this.$message.success('操作成功')
            }
          })
        } else {
          return false
        }
      })
    },
    // 获取公司列表
    getdata(parameter) {
    //   this.loading = true
      loadCustomerList({
        page:this.formInline.page,
        pageSize:this.formInline.limit,
        nickName:this.formInline.nickName,
        phone:this.formInline.phone
      }).then(res=>{
        this.listData = res.pageInfo.list
        this.pageparm.total = res.pageInfo.total
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    resetting(){
        this.formInline.phone = ''
        this.formInline.nickName = '' 
        this.getdata()
    },
    //显示编辑界面
    handleEdit: function(row) {
      usersDetail({id:row.id}).then(res=>{
        this.editFormVisible = true
        this.editForm = res.data
      })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
  
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/userList/index.vue